export enum EventVenueType {
  NORMAL = 'Normal',
  ONLINE = 'Online'
}
